import { Link, Typography } from '@mui/material'

import { Head } from '@/components/layouts'
import { ConsoleBaseLayout } from '@/components/layouts/ConsoleBaseLayout'
import { ArtistThemeProvider } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Cell, CellFrame, Template } from '@/core/architecture'
import { getHelpUrl } from '@/lib/helpUrl'

import {
  CollectionCreateForm,
  CollectionCreateFormProps,
  FileUploadInfo,
} from './CollectionCreateForm'

export * from './fragments'

export type State = {
  artistId: string
  progress: number
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onSubmit: CollectionCreateFormProps['onSubmit']
  onDrop: FileUploadInfo['onDrop']
}

export const ConsoleCollectionCreateTemplate: Template<State, Action> = ({
  state,
  onSubmit,
  onDrop,
}) => {
  const { routerNames, routerPages } = useRouter()
  const { t } = useTranslation('consoleCollectionCreate')
  return (
    <ArtistThemeProvider artistId={state.artistId}>
      <Head title={routerNames.ConsoleCollectionCreate} />
      <ConsoleBaseLayout
        margin
        header={{
          title: t('title'),
          back: true,
          defaultBackPage: routerPages.ConsoleCollections,
        }}
      >
        <HeadingTextCell />
        <CollectionCreateForm
          artistId={state.artistId}
          fileUploadInfo={{ progress: state.progress, onDrop }}
          onSubmit={onSubmit}
        />
      </ConsoleBaseLayout>
    </ArtistThemeProvider>
  )
}

export const HeadingTextCell: Cell = () => {
  const { t } = useTranslation('consoleCollectionCreate')
  return (
    <CellFrame sx={{ pt: 5, mb: 2 }}>
      <Typography variant="body2" color="text.secondary">
        {t('description')}
      </Typography>
      <Link
        variant="subtitle1"
        sx={{ py: 2 }}
        component="a"
        target="_blank"
        href={getHelpUrl('collection')}
      >
        {t('gotoDetail')}
      </Link>
    </CellFrame>
  )
}
